/*
  Gridline cart behaviour (research-use attestation, upsell + free-gift engine).

  Loaded once from layout/theme.liquid. These used to live as inline <script> tags inside
  the cart snippets, which only works when the cart already has items at page load: when a
  customer adds the first item, the theme renders the drawer in with DOM APIs and inline
  scripts are never executed, so nothing was wired up (the attestation could not unlock
  Check out, the free water was never auto-added). Custom
  elements defined here upgrade automatically whenever the theme renders their markup.
*/

/* ---------- Research-use attestation (snippets/gridline-research-attestation.liquid) ---------- */
(function () {
  if (!window.customElements || customElements.get('gridline-research-attestation')) return;

  var pending = null;

  function updateUrl() {
    try {
      if (window.Theme && Theme.routes && Theme.routes.cart_update_url) return Theme.routes.cart_update_url;
    } catch (e) {}
    return '/cart/update.js';
  }

  function stamp() {
    var d = new Date();
    function two(n) { return (n < 10 ? '0' : '') + n; }
    return d.getUTCFullYear() + '-' + two(d.getUTCMonth() + 1) + '-' + two(d.getUTCDate()) + ' ' + two(d.getUTCHours()) + ':' + two(d.getUTCMinutes()) + ' UTC';
  }

  /* The cart page also carries the older "I certify that I am at least twenty-one..." checkbox
     (#researchConfirm, a Custom Liquid block in templates/cart.json). The two act as one control:
     ticking either ticks both, so a customer never has to confirm twice and its alert never fires. */
  function legacyBoxes() { return document.querySelectorAll('input#researchConfirm'); }

  class GlAttest extends HTMLElement {
    connectedCallback() {
      this.glBox = this.querySelector('.gl-attest__box');
      if (!this.glBox) return;
      if (!this.glBound) {
        this.glBound = true;
        this.glBox.addEventListener('change', this.glOnChange.bind(this));
        /* The theme morphs the cart HTML in place after every cart change.
           Server HTML wins; this keeps the button, the box and the legacy box in step. */
        this.glObs = new MutationObserver(this.glSync.bind(this));
      }
      var scope = this.closest('cart-items-component') || this.closest('.cart__ctas');
      if (scope && this.glObs) {
        this.glObs.observe(scope, { attributes: true, childList: true, characterData: true, subtree: true });
      }
      this.glSync();
    }
    disconnectedCallback() { if (this.glObs) this.glObs.disconnect(); }
    glSync() {
      var ctas = this.closest('.cart__ctas');
      if (!ctas || !this.glBox) return;
      var on = this.glBox.checked;
      if (ctas.classList.contains('gl-attest--locked') === on) ctas.classList.toggle('gl-attest--locked', !on);
      if (this.classList.contains('gl-attest--done') !== on) this.classList.toggle('gl-attest--done', on);
      var btn = ctas.querySelector('.cart__checkout-button');
      if (btn) {
        var dis = btn.getAttribute('aria-disabled') === 'true';
        if (on && dis) btn.removeAttribute('aria-disabled');
        if (!on && !dis) btn.setAttribute('aria-disabled', 'true');
        /* Truly disabled while locked: no click, key or implicit form submit can fire it. */
        if (btn.disabled !== !on) btn.disabled = !on;
      }
      var extra = ctas.querySelector('.additional-checkout-buttons');
      if (extra) {
        var inert = extra.hasAttribute('inert');
        if (on && inert) extra.removeAttribute('inert');
        if (!on && !inert) extra.setAttribute('inert', '');
      }
      legacyBoxes().forEach(function (b) { if (b.checked !== on) b.checked = on; });
    }
    glOnChange() {
      var on = this.glBox.checked;
      var value = on ? 'Confirmed ' + stamp() + ': ' + (this.dataset.statement || '') : '';
      if (on) this.glBox.value = value;
      var hint = this.querySelector('.gl-attest__hint');
      if (hint && on) hint.hidden = true;
      this.classList.remove('gl-attest--nudge');
      this.glSync();

      var attrs = {};
      attrs[this.dataset.key || 'Research use attestation'] = value;
      if (pending) pending.abort();
      var ac = new AbortController();
      pending = ac;
      fetch(updateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        signal: ac.signal
      }).catch(function () {}).finally(function () { if (pending === ac) pending = null; });
    }
  }
  customElements.define('gridline-research-attestation', GlAttest);

  /* Ticking the legacy cart-page box ticks the attestation too (and records it). */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'researchConfirm' || t.type !== 'checkbox') return;
    document.querySelectorAll('gridline-research-attestation').forEach(function (el) {
      var b = el.querySelector('.gl-attest__box');
      if (b && b.checked !== t.checked) { b.checked = t.checked; el.glOnChange(); }
    });
  });

  /* A locked Checkout button never submits (it is disabled, and the shield over it
     catches the click): point the customer at the box instead. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.gl-attest--locked .cart__checkout-button, .gl-attest--locked .gl-attest__shield, .gl-attest--locked .gl-attest__guard');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var ctas = btn.closest('.cart__ctas');
    var el = ctas && ctas.querySelector('gridline-research-attestation');
    if (!el) return;
    var hint = el.querySelector('.gl-attest__hint');
    if (hint) hint.hidden = false;
    el.classList.remove('gl-attest--nudge');
    void el.offsetWidth;
    el.classList.add('gl-attest--nudge');
    var box = el.querySelector('.gl-attest__box');
    if (box) box.focus();
  }, true);
})();

/* ---------- Upsell add + free-gift engine (snippets/gridline-cart-upsell.liquid) ---------- */
(function () {
  if (window.glUpsellSubmit) return;

  /* Wired via inline onsubmit on the upsell forms. If this script never ran
     (or was blocked), the inline handler fails and the browser simply
     performs the native form POST to /cart/add - the item is still added
     and Shopify shows the cart. When it does run, we upgrade to an AJAX add
     that refreshes the drawer and cart page in place. */
  window.glUpsellSubmit = function (form) {
    try {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        if (btn.disabled) return false;
        btn.disabled = true;
        btn.textContent = '...';
      }

      var wrap = form.closest('[data-gl-upsell]');
      var fd = new FormData(form);

      /* Ask Shopify to render the affected cart sections in the same
         round-trip, exactly like the theme's own add-to-cart flow. */
      var ids = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset && el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) < 0) {
          ids.push(el.dataset.sectionId);
        }
      });
      if (ids.length) {
        fd.append('sections', ids.join(','));
        fd.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json && json.status && json.message) throw new Error(json.message);
          /* Same shape as the theme's CartAddEvent: components morph from
             detail.data.sections, or re-fetch their section if absent. */
          var ev = new Event('cart:update', { bubbles: true });
          ev.detail = {
            resource: null,
            sourceId: 'gridline-cart-upsell',
            data: {
              source: 'gridline-cart-upsell',
              variantId: String(fd.get('id')),
              sections: (json && json.sections) || undefined
            }
          };
          (wrap || document).dispatchEvent(ev);
        })
        .catch(function (err) {
          if (btn) {
            btn.disabled = false;
            btn.textContent = '+ Add';
          }
          var msg = wrap && wrap.querySelector('[data-gl-upsell-error]');
          if (msg) {
            msg.hidden = false;
            msg.textContent = (err && err.message) || 'Could not add - please try again.';
          }
        });

      return false;
    } catch (e) {
      /* Anything unexpected: fall back to the native form submission. */
      return true;
    }
  };

  /* ------------------------------------------------------------------
     Free-gift engine. Keeps the hidden $0 bacteriostatic water in sync
     with the cart: crossing the threshold adds it, dropping below
     removes it, and its quantity is pinned to 1. State is read fresh
     from /cart.js on every pass, so it always converges.
  ------------------------------------------------------------------ */
  var giftBusy = false;

  function glGiftSections() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId && ids.indexOf(el.dataset.sectionId) < 0) {
        ids.push(el.dataset.sectionId);
      }
    });
    return ids;
  }

  function glGiftNotify(sections) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: null,
      sourceId: 'gridline-free-gift',
      data: { source: 'gridline-free-gift', sections: sections || undefined }
    };
    document.dispatchEvent(ev);
  }

  function glGiftSync() {
    var marker = document.querySelector('[data-gl-gift]');
    if (!marker || giftBusy) return;
    var vid = marker.getAttribute('data-gift-variant');
    var th = parseInt(marker.getAttribute('data-threshold'), 10) || 20000;
    var paidId = marker.getAttribute('data-paid-product-id') || '';
    var paidHandle = marker.getAttribute('data-paid-handle') || '';
    if (!vid) return;
    giftBusy = true;

    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = null;
        var paidBac = 0;
        (cart.items || []).forEach(function (it) {
          if (String(it.variant_id) === String(vid)) gift = it;
          else if ((paidId && String(it.product_id) === paidId) || (paidHandle && it.handle === paidHandle)) paidBac += it.final_line_price;
        });
        var qualifying = (cart.total_price || 0) - paidBac;

        if (qualifying >= th && !gift) {
          var fd = new FormData();
          fd.append('id', vid);
          fd.append('quantity', '1');
          var secs = glGiftSections();
          if (secs.length) { fd.append('sections', secs.join(',')); fd.append('sections_url', window.location.pathname); }
          return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
            .then(function (r) { return r.json(); })
            .then(function (json) { glGiftNotify(json && json.sections); return true; });
        }

        if (gift && (qualifying < th || gift.quantity > 1)) {
          var updates = {};
          updates[vid] = qualifying < th ? 0 : 1;
          var body = { updates: updates };
          var secs2 = glGiftSections();
          if (secs2.length) { body.sections = secs2.join(','); body.sections_url = window.location.pathname; }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          })
            .then(function (r) { return r.json(); })
            .then(function (json) { glGiftNotify(json && json.sections); return true; });
        }

        return false;
      })
      .then(function (acted) {
        giftBusy = false;
        if (acted) setTimeout(glGiftSync, 400);
      })
      .catch(function () { giftBusy = false; });
  }

  document.addEventListener('cart:update', function () { setTimeout(glGiftSync, 150); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { glGiftSync(); });
  } else {
    glGiftSync();
  }
  setInterval(function () {
    if (!document.visibilityState || document.visibilityState === 'visible') glGiftSync();
  }, 8000);
})();
